import React, { useContext, useState } from 'react';
import { AdminContext } from '../../context/AdminContext';
import Avatar from '../Avatar';
import style from './style.module.css';
import blanckUser from '../../../../assets/imgs/blank-profile-picture.png';
import Button from '../Button';
import FileSection from '../FileSection';

export default function UserInfo({ setReplyValue,
  zoomContent,
  downloadedFiles,
  setDownloadedFiles,
  chatBody}) {
  const {
    showUserInfo,
    content,
    privateUsers,
    setShowFirstMessage,
    setUserChannelId,
    setSharedUserClicked,
    userChannelId,
    setActiveUser,
    setSharedUser,
    setShowUserInfo,
    previousChannelId,
    setPreviousChannelId,
    setZoomeContent,
    setOpenZoomModal,
  } = useContext(AdminContext);
  //   const [previousChannelId, setPreviousChannelId] = useState('');

  const switchToShare = (user) => {
    console.log('userrrrrrr', user, userChannelId);
    if (userChannelId != user?.uuid) {
      setActiveUser();
      setSharedUserClicked(user?.channelName);
      startChatFunction(user);
      setSharedUser(user);
    }
    setReplyValue({ id: '' });
  };
  const startChatFunction = (y) => {
    console.log('sssss', privateUsers, y.uuid);
    let index = privateUsers.findIndex(
      (x) => x?.users?.[0]?.channelUser?.uuid == y.uuid
    );
    if (index == -1) {
      setShowFirstMessage(true);
      setPreviousChannelId(userChannelId);
      setUserChannelId(y?.uuid);
      const newuser = {
        ...y,
        block: 0,
        users: [
          {
            unSeen: 0,
            block: 0,
            channelUser: {
              channelName: y?.name,
              uuid: y?.uuid,
            },
          },
        ],
      };
    } else {
      setUserChannelId(y?.uuid);
    }
  };
  return (
    <div
      className={`${style.container} flex flex-col justify-start items-center w-full h-auto`}
    >
      <Avatar
        width={100}
        height={100}
        src={showUserInfo?.image?.name ? showUserInfo?.image?.name : blanckUser}
        local={
          showUserInfo?.image?.name?.length != 0 &&
          showUserInfo?.image?.name != undefined
            ? false
            : true
        }
        onClick={()=>{
          if (showUserInfo?.image?.name?.length != 0 &&
            showUserInfo?.image?.name != undefined){
          setOpenZoomModal(true);
          setZoomeContent({ item: {file:{fileExtension:{type:"image"},name:showUserInfo?.image?.name}}, type: 'image' });
            }
        }}
      />
      <p>
        {content?.personalInfoModal?.title}: {showUserInfo?.channelName}
      </p>
      {showUserInfo?.username && (
        <p>
          {content?.personalInfoModal?.username}: {showUserInfo?.username}
        </p>
      )}
      {showUserInfo?.content && (
        <p>
          {content?.personalInfoModal?.description}: {showUserInfo?.content}
        </p>
      )}
      <Button
        className={`sendBtn  ${style.button}`}
        onClick={() => {
          switchToShare(showUserInfo);
          setShowUserInfo();
        }}
      >
        {content?.conversation}
      </Button>
      <FileSection
        content={content}
        uuidUser={showUserInfo?.uuid}
        extraScrollDivStyle={style.scrollDivOuter}
        extraScrollDivStyleInside={style.scrollDivInside}
      />
    </div>
  );
}
